module.exports = __webpack_public_path__ + "static/img/hzhb_banner.ad17b80.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_banner.png
// module id = 8Nkl
// module chunks = 0